const adminRequestsSplitView = {
  emptyState: "No data requests for this project yet.",
  filters: {
    allProjects: "All projects",
    allStatuses: "All statuses",
    allTypes: "All types",
    sortNewest: "Newest first",
    sortOldest: "Oldest first",
    sortStatusPriority: "Status priority",
  },
  requestType: {
    access: "Access request",
    data: "Data request",
  },
  list: {
    noMatch: "No requests match these filters.",
    fallbackUser: "User {{id}}",
    fallbackProject: "Project {{id}}",
  },
  detail: {
    requestedBy: "requested by",
    requestTitleLabel: "Request title",
    requestLabel: "Request",
    submitted: "Submitted",
    requestedFields: "Requested fields",
    filterCriteria: "Filter criteria",
    processingNotes: "Processing notes from requester",
    reviewNotes: "Review notes",
    files: {
      uploadData: "Upload data",
      label: "Files",
      notUploadedYet:
        "Not uploaded yet — you'll be asked to upload once this request is approved.",
      requestedFiles: "Requested files (1)",
    },
    sources: {
      forwardedTo: "Forwarded to",
      recipientHeader: "Recipient",
      forwardedHeader: "Forwarded",
      statusHeader: "Status",
      notesHeader: "Notes",
      unknownRecipient: "Unknown",
      orgSuffix: "(org)",
      status: {
        pending: "Pending",
        fulfilled: "Fulfilled",
        declined: "Declined",
      },
    },
    archived: {
      noteBefore:
        "This project is archived and read-only. Restore it in the project's Settings -`",
      noteAfter: "` Project Controls to act on this request.",
    },
    actions: {
      notesPlaceholder: "Add review notes (required for rejection)…",
      approve: "Approve",
      reject: "Reject",
      rejectRequiresNotes: "Review notes are required to reject a request",
      forward: "Forward to data supplier",
      forwardHint: "Ask a data uploader or PI to provide the data for this request",
    },
  },
};

export default adminRequestsSplitView;
